import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getErrorString } from '@utils/utils.js';
import { reviewsListingApi } from '@apis/cp/cp-reviews.js';
import { Toast } from '@common-web/index.js';

const initialState = {
  reviews: [],
  statuses: [],
  pagination: null,
  success: false,
  loading: false,
  aggregations: null,
};

export const fetchReviewsListing = createAsyncThunk('reviews/listing', async (params = '') => {
  try {
    const reviews = await reviewsListingApi(params);
    return reviews;
  } catch (err) {
    Toast.error(getErrorString(err));
  }
});

const CpReviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    updateReview: (state, action) => {
      const review = action.payload;
      const index = state.reviews.findIndex((item) => item.id === review.id);
      if (index !== -1) {
        state.reviews[index] = {
          ...state.reviews[index],
          comment: review.comment,
        };
      }
    },
    setReviews: (state, action) => {
      state.reviews = action.payload?.reviews;
      state.pagination = action?.payload?.pagination ?? state?.pagination;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchReviewsListing.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReviewsListing.fulfilled, (state, action) => {
        state.reviews = action?.payload?.reviews;
        state.pagination = action?.payload?.pagination;
        state.aggregations = action?.payload?.aggregations;
        state.loading = false;
        state.statuses = action?.payload?.statuses_and_dispositions ?? [];
      });
  },
});

export const { updateReview, setReviews } = CpReviewsSlice.actions;
export default CpReviewsSlice.reducer;
